import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface UserState {
  name: string;
  phone: string;
  linkedinUrl: string;
  isNameBound: boolean;
}

const initialState: UserState = {
  name: '',
  phone: '',
  linkedinUrl: '',
  isNameBound: false,
};

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setName: (state, action: PayloadAction<string>) => {
      state.name = action.payload;
      state.isNameBound = action.payload.trim() !== '';
    },
    setPhone: (state, action: PayloadAction<string>) => {
      state.phone = action.payload;
    },
    setLinkedinUrl: (state, action: PayloadAction<string>) => {
      state.linkedinUrl = action.payload;
    },
    clearUser: (state) => {
      state.name = '';
      state.phone = '';
      state.linkedinUrl = '';
      state.isNameBound = false;
    },
  },
});

export const { setName, setPhone, setLinkedinUrl, clearUser } = userSlice.actions;
export default userSlice.reducer;
